module.exports = __webpack_public_path__ + "img/00013.b0e930db.webp";